var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIls041(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 75,
    viewBox: "0 0 94 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.03
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.7675 40.0015C61.9674 39.9019 70.1514 40.7486 78.1571 42.5248C90.0252 45.4507 91.8242 49.8888 91.8242 52.2779C91.8242 54.667 90.0342 59.1052 78.1571 62.0311C62.0746 65.3961 45.4694 65.3961 29.3869 62.0311C17.5188 59.1052 15.7288 54.667 15.7288 52.2779C15.7288 49.8888 17.5188 45.4507 29.3869 42.5248C37.3898 40.75 45.5707 39.9033 53.7675 40.0015Z",
    fill: "#FDFDFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.06
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2218 40.7353C61.1899 40.6391 69.1425 41.4617 76.9221 43.187C88.4412 46.0145 90.2133 50.3453 90.2133 52.6449C90.2133 54.9445 88.4233 59.2752 76.9221 62.1028C61.2795 65.3768 45.1282 65.3768 29.4855 62.1028C17.9575 59.2752 16.1943 54.9445 16.1943 52.6449C16.1943 50.3453 17.9844 46.0145 29.4855 43.187C37.2767 41.4581 45.2416 40.6354 53.2218 40.7353Z",
    fill: "#FAFBFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6757 41.469C60.4146 41.3762 68.1385 42.1718 75.6959 43.8401C86.8749 46.5871 88.6112 50.7479 88.6112 53.0117C88.6112 55.2755 86.8749 59.4363 75.6959 62.1833C60.512 65.3448 44.8394 65.3448 29.6555 62.1833C18.4765 59.4363 16.7312 55.2666 16.7312 53.0117C16.7312 50.7568 18.5213 46.5871 29.6555 43.8401C37.2129 42.1718 44.9368 41.3762 52.6757 41.469Z",
    fill: "#F8F9FD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.13
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1296 42.2385C59.652 42.1474 67.16 42.9221 74.5054 44.547C85.3352 47.2314 87.0358 51.2311 87.0358 53.4233C87.0358 55.6155 85.3173 59.6868 74.5054 62.2996C59.7699 65.3658 44.5608 65.3658 29.8254 62.2996C18.9955 59.6152 17.2949 55.6155 17.2949 53.4233C17.2949 51.2311 19.0134 47.1598 29.8254 44.547C37.1474 42.9275 44.631 42.1529 52.1296 42.2385Z",
    fill: "#F6F7FC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.16
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5838 42.9275C58.865 42.8433 66.132 43.5908 73.2435 45.1555C83.7332 47.7146 85.4158 51.6158 85.4158 53.7454C85.4158 55.875 83.7332 59.7673 73.2435 62.3264C58.9596 65.2972 44.2169 65.2972 29.933 62.3264C19.4433 59.7673 17.7517 55.875 17.7517 53.7454C17.7517 51.6158 19.4433 47.7146 29.933 45.1555C37.0415 43.5908 44.3055 42.8433 51.5838 42.9275Z",
    fill: "#F3F5FC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.19
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0378 43.6612C58.0897 43.5811 65.128 44.3015 72.0174 45.8086C82.1581 48.2872 83.8228 52.0722 83.8228 54.1123C83.8228 56.1524 82.1581 59.9284 72.0174 62.407C58.1806 65.2702 43.9039 65.2702 30.0672 62.407C19.9265 59.9284 18.2617 56.1435 18.2617 54.1123C18.2617 52.0811 19.9265 48.2872 30.0672 45.8086C36.9535 44.3012 43.9888 43.5808 51.0378 43.6612Z",
    fill: "#F1F3FB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4919 44.3949C57.3153 44.312 64.1259 45.0085 70.7912 46.4708C80.6365 48.8509 82.2207 52.4748 82.2207 54.4702C82.2207 56.4656 80.5918 60.0985 70.7912 62.5233C57.4029 65.2904 43.5898 65.2904 30.2015 62.5233C20.4009 60.1432 18.772 56.5193 18.772 54.4702C18.772 52.4212 20.4009 48.8509 30.2015 46.4708C36.8638 45.0089 43.6714 44.3124 50.4919 44.3949Z",
    fill: "#EFF1FA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.26
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9547 45.1287C56.5458 45.0503 63.1246 45.7197 69.5648 47.1241C79.0164 49.4237 80.6185 52.9133 80.6185 54.8371C80.6185 56.7609 79.0164 60.2595 69.5648 62.5591C56.6238 65.2196 43.2766 65.2196 30.3356 62.5591C20.8841 60.2595 19.282 56.7698 19.282 54.8371C19.282 52.9044 20.8841 49.4237 30.3356 47.1241C36.7788 45.7193 43.3606 45.0499 49.9547 45.1287Z",
    fill: "#ECEFFA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.29
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4088 45.8623C55.7623 45.7879 62.1038 46.4333 68.3119 47.7861C77.4144 49.9873 78.9986 53.3427 78.9986 55.2039C78.9986 57.0651 77.4144 60.4295 68.3119 62.6306C55.8224 65.1958 42.9416 65.1958 30.4521 62.6306C21.3406 60.4295 19.7654 57.074 19.7654 55.2039C19.7654 53.3338 21.3406 49.9873 30.4521 47.7861C36.6777 46.4293 43.0374 45.7838 49.4088 45.8623Z",
    fill: "#EAEDF9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.32
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8629 46.5871C54.9964 46.5177 61.1181 47.139 67.1125 48.4393C75.8748 50.56 77.4232 53.8081 77.4232 55.5976C77.4232 57.3872 75.8748 60.6174 67.1125 62.7559C55.0715 65.2255 42.6543 65.2255 30.6132 62.7559C21.8509 60.6442 20.3025 57.3872 20.3025 55.5976C20.3025 53.8081 21.8509 50.5868 30.6132 48.4393C36.6075 47.138 42.7294 46.5167 48.8629 46.5871Z",
    fill: "#E8EBF9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3167 47.3208C54.2218 47.256 60.1155 47.8563 65.8862 49.1104C74.2994 51.1326 75.821 54.2107 75.821 55.9466C75.821 57.6825 74.2994 60.7605 65.8862 62.7917C54.2855 65.1664 42.3247 65.1756 30.7205 62.8186C22.3072 60.7874 20.7856 57.7093 20.7856 55.9734C20.7856 54.2375 22.3072 51.1595 30.7205 49.1373C36.4989 47.8721 42.4016 47.2628 48.3167 47.3208Z",
    fill: "#E5E9F8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.39
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7711 48.0546C53.4466 47.9904 59.1115 48.5607 64.6603 49.7547C72.7156 51.6874 74.2282 54.6402 74.2282 56.3045C74.2282 57.9688 72.7335 60.9216 64.6603 62.8543C53.518 65.1212 42.0332 65.1212 30.8909 62.8543C22.8356 60.9216 21.323 57.9688 21.323 56.3045C21.323 54.6402 22.8177 51.6874 30.8909 49.7547C36.4366 48.5606 42.0986 47.9903 47.7711 48.0546Z",
    fill: "#E3E7F7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.42
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2246 48.7883C52.6711 48.7238 58.1077 49.267 63.4336 50.4079C71.1578 52.2601 72.6257 55.0698 72.6257 56.6714C72.6257 58.2731 71.1578 61.0827 63.4336 62.935C52.7386 65.0943 41.7196 65.0943 31.0245 62.935C23.3004 61.0827 21.8325 58.2731 21.8325 56.6714C21.8325 55.0698 23.3004 52.2601 31.0245 50.4079C36.3474 49.2669 41.7811 48.7237 47.2246 48.7883Z",
    fill: "#E1E5F7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M46.679 49.5221C51.8967 49.4592 57.1051 49.9784 62.2077 51.07C69.5916 52.8596 71.0326 55.544 71.0326 57.0383C71.0326 58.5326 69.5916 61.2528 62.2077 63.0065C51.9611 65.0704 41.4057 65.0704 31.1592 63.0065C23.7752 61.217 22.3342 58.5326 22.3342 57.0383C22.3342 55.544 23.7752 52.8238 31.1592 51.07C36.2588 49.9788 41.4642 49.4597 46.679 49.5221Z",
    fill: "#DEE3F6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.48
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1419 50.2915C51.1277 50.2363 56.1044 50.7314 60.9815 51.768C68.0164 53.4412 69.4306 55.9734 69.4306 57.4498C69.4306 58.9262 68.0164 61.4585 60.9815 63.1228C51.1864 65.0913 41.0974 65.0913 31.3023 63.1228C24.2584 61.4585 22.8442 58.9173 22.8442 57.4498C22.8442 55.9824 24.2584 53.4412 31.3023 51.768C36.1793 50.7305 41.156 50.2353 46.1419 50.2915Z",
    fill: "#DCE1F5"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.52
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M45.596 50.9806C50.3531 50.927 55.1016 51.3981 59.7554 52.3854C66.4502 53.9602 67.8106 56.3672 67.8106 57.7542C67.8106 59.1411 66.4323 61.557 59.7554 63.1229C50.4076 64.984 40.7844 64.984 31.4366 63.1229C24.7418 61.5391 23.3813 59.1411 23.3813 57.7542C23.3813 56.3672 24.7686 53.9423 31.4366 52.3854C36.0904 51.3981 40.8389 50.927 45.596 50.9806Z",
    fill: "#DADEF5"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.55
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0409 51.7143C49.5687 51.6644 54.0885 52.1084 58.52 53.0386C64.8658 54.5239 66.2263 56.7967 66.2263 58.1389C66.2263 59.481 64.8658 61.718 58.52 63.2302C49.6207 64.9959 40.461 64.9959 31.5617 63.2302C25.2159 61.7448 23.8555 59.4721 23.8555 58.1389C23.8555 56.8056 25.2159 54.5597 31.5617 53.0386C35.9932 52.1084 40.513 51.6644 45.0409 51.7143Z",
    fill: "#D8DCF4"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.58
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M44.504 52.448C48.8026 52.4021 53.0937 52.8191 57.303 53.6917C63.2997 55.0965 64.6333 57.2709 64.6333 58.4967C64.6333 59.7226 63.2997 61.9059 57.303 63.3107C48.851 64.9691 40.1571 64.9691 31.7051 63.3107C25.7084 61.9059 24.3748 59.7763 24.3748 58.4967C24.3748 57.2172 25.7084 55.0965 31.7051 53.6917C35.9144 52.8197 40.2055 52.4027 44.504 52.448Z",
    fill: "#D5DAF3"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.61
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9581 53.1817C48.0279 53.138 52.0908 53.531 56.0768 54.3539C61.7334 55.6603 63.0311 57.6646 63.0311 58.8278C63.0311 59.991 61.7334 62.0401 56.0768 63.3018C48.0763 64.8646 39.8489 64.8646 31.8484 63.3018C26.1918 61.9954 24.885 59.991 24.885 58.8278C24.885 57.6646 26.1918 55.6245 31.8484 54.3539C35.8313 53.531 39.8912 53.1381 43.9581 53.1817Z",
    fill: "#D3D8F3"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.65
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4121 53.9154C47.2649 53.8684 51.1116 54.2344 54.8864 55.0071C60.1939 56.2329 61.4738 58.0941 61.4738 59.2304C61.4738 60.3668 60.1939 62.2369 54.8864 63.4539C47.3343 64.9203 39.5705 64.9203 32.0183 63.4539C26.7108 62.2369 25.4309 60.3758 25.4309 59.2304C25.4309 58.0851 26.7108 56.2329 32.0183 55.0071C35.7667 54.2399 39.5862 53.8739 43.4121 53.9154Z",
    fill: "#D1D6F2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.68
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M42.875 54.6403C46.4814 54.6016 50.0818 54.9466 53.6153 55.6693C58.5827 56.7967 59.8268 58.5236 59.8268 59.5974C59.8268 60.6711 58.5827 62.398 53.6153 63.5344C46.5194 64.891 39.2306 64.891 32.1346 63.5344C27.1672 62.398 25.9231 60.6711 25.9231 59.5974C25.9231 58.5236 27.1672 56.7967 32.1346 55.6693C35.6681 54.9468 39.2685 54.6018 42.875 54.6403Z",
    fill: "#CED4F1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.71
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3558 55.3739C45.7361 55.3382 49.1108 55.6561 52.4249 56.3224C57.0433 57.3603 58.2695 58.9531 58.2695 59.9642C58.2695 60.9753 57.0433 62.577 52.4249 63.606C45.7718 64.8706 38.9399 64.8706 32.2867 63.606C27.6594 62.577 26.4421 60.9753 26.4421 59.9642C26.4421 58.9531 27.6594 57.3603 32.2867 56.3224C35.6008 55.6557 38.9755 55.3378 42.3558 55.3739Z",
    fill: "#CCD2F1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.74
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7831 56.1077C44.9353 56.0805 48.0817 56.3804 51.172 57.0025C55.4502 57.951 56.6407 59.4184 56.6407 60.3579C56.6407 61.2974 55.4502 62.7649 51.172 63.7134C44.9604 64.8728 38.5879 64.8728 32.3763 63.7134C28.0981 62.7649 26.9077 61.2974 26.9077 60.3579C26.9077 59.4184 28.0981 57.951 32.3763 57.0025C35.4724 56.3787 38.625 56.0788 41.7831 56.1077Z",
    fill: "#CAD0F0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.77
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2372 56.8414C44.1597 56.8076 47.078 57.0745 49.9458 57.6378C53.875 58.4879 55.0386 59.8211 55.0386 60.698C55.0386 61.5749 53.875 62.9081 49.9458 63.7581C44.1886 64.82 38.2857 64.82 32.5285 63.7581C28.5993 62.9081 27.4358 61.5749 27.4358 60.698C27.4358 59.8211 28.5993 58.4879 32.5285 57.6378C35.3964 57.0745 38.3147 56.8076 41.2372 56.8414Z",
    fill: "#C7CEF0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.81
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6912 57.5752C43.3935 57.543 46.0922 57.7828 48.7465 58.291C52.3266 59.0605 53.4722 60.2505 53.4722 61.0648C53.4722 61.879 52.3355 63.0691 48.7465 63.8297C43.4378 64.7961 37.9983 64.7961 32.6896 63.8297C29.1095 63.0691 27.9639 61.879 27.9639 61.0648C27.9639 60.2505 29.1095 59.0605 32.6896 58.291C35.3263 57.7864 38.0068 57.5466 40.6912 57.5752Z",
    fill: "#C5CCEF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.84
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1453 58.3447C42.6103 58.3193 45.0717 58.5381 47.4935 58.9979C50.7335 59.6689 51.8433 60.7248 51.8433 61.4764C51.8433 62.2281 50.7335 63.266 47.4935 63.955C42.6354 64.8141 37.6642 64.8141 32.8061 63.955C29.5571 63.275 28.4473 62.2191 28.4473 61.4764C28.4473 60.7338 29.5571 59.6868 32.8061 58.9979C35.2249 58.538 37.6833 58.3192 40.1453 58.3447Z",
    fill: "#C3CAEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.87
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5992 59.0336C41.835 59.0119 44.0678 59.2036 46.2672 59.6063C49.1671 60.1968 50.2501 61.1185 50.2501 61.7985C50.2501 62.4786 49.1671 63.4002 46.2672 63.9818C41.8577 64.7454 37.3496 64.7454 32.9401 63.9818C30.0402 63.4002 28.9573 62.4786 28.9573 61.7985C28.9573 61.1185 30.0402 60.1968 32.9401 59.6063C35.1365 59.204 37.3663 59.0123 39.5992 59.0336Z",
    fill: "#C0C8EE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.9
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0622 59.7674C41.0664 59.7481 43.068 59.9159 45.041 60.2684C47.5919 60.7606 48.6212 61.548 48.6212 62.1654C48.6212 62.7828 47.565 63.5613 45.041 64.0623C41.0792 64.7186 37.0363 64.7186 33.0745 64.0623C30.5237 63.5613 29.4944 62.7739 29.4944 62.1654C29.4944 61.5569 30.5505 60.7606 33.0745 60.2684C35.0505 59.916 37.0551 59.7482 39.0622 59.7674Z",
    fill: "#BEC6ED"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.94
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5161 60.501C40.2912 60.4859 42.0642 60.6267 43.8147 60.9216C46.0165 61.3332 47.0457 61.9774 47.0457 62.5233C47.0457 63.0691 46.0165 63.7223 43.8147 64.1339C40.3046 64.6946 36.7277 64.6946 33.2175 64.1339C31.0068 63.7223 29.9775 63.0781 29.9775 62.5233C29.9775 61.9685 31.0068 61.3332 33.2175 60.9216C34.9679 60.6259 36.741 60.4852 38.5161 60.501Z",
    fill: "#BCC4EC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.97
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9702 61.2348C39.5164 61.2233 41.0609 61.337 42.5886 61.5748C44.4503 61.9059 45.4528 62.407 45.4528 62.8902C45.4528 63.3734 44.4503 63.8834 42.5886 64.2055C39.5273 64.6708 36.4132 64.6708 33.3519 64.2055C31.4902 63.8834 30.4878 63.3734 30.4878 62.8902C30.4878 62.407 31.4902 61.9059 33.3519 61.5748C34.8797 61.337 36.4241 61.2233 37.9702 61.2348Z",
    fill: "#B9C2EC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8507 63.257C43.8507 63.9728 40.9777 64.5544 37.4244 64.5544C33.8711 64.5544 30.998 63.9728 30.998 63.257C30.998 62.5412 33.8711 61.9686 37.4244 61.9686C40.9777 61.9686 43.8507 62.5412 43.8507 63.257Z",
    fill: "#B7C0EB"
  })))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3445 61.3906C63.6682 54.2634 68.6899 37.6875 61.5608 24.3674C54.4316 11.0474 37.8513 6.02703 24.5276 13.1542C11.2038 20.2815 6.18215 36.8573 13.3113 50.1774C20.4405 63.4975 37.0208 68.5178 50.3445 61.3906Z",
    fill: "url(#paint0_linear_156_20262)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_156_20262",
    x1: 24.5276,
    y1: 13.1542,
    x2: 50.3336,
    y2: 61.3964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE4FC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIls041);
export default __webpack_public_path__ + "static/media/ils_04_1.15ccc7d50e1c0ae569eddb68fd03baac.svg";
export { ForwardRef as ReactComponent };